import PropTypes from "prop-types";
import "./RoomCapacity.scss";
import IconAdult from "app/pages/.shared/static/icons/IconAdult";
import IconChild from "app/pages/.shared/static/icons/IconChild";
import IconBaby from "app/pages/.shared/static/icons/IconBaby";
import { memo } from "react";
import { useIntl } from "react-intl";

const RoomCapacity = ({ adultCount = 0, childCount = 0, babyCount = 0 }) => {
	const intl = useIntl();

	const getLabel = (count, singularKey, pluralKey) => {
		if (count > 0) {
			const message = count === 1 ? singularKey : pluralKey;
			return intl.formatMessage({ id: message }, { value: count });
		}
		return "";
	};

	const ariaLabel = [
		getLabel(adultCount, "general.adult.singular", "general.adult.plural"),
		getLabel(childCount, "general.child.singular", "general.child.plural"),
		getLabel(babyCount, "general.infant.singular", "general.infant.plural"),
	]
		.filter(label => label !== "")
		.join(", ");

	return (
		<div className="room-capacity" role="img" aria-label={ariaLabel}>
			{Array.from({ length: adultCount }, (_, index) => (
				<IconAdult key={`adult-${index}`} />
			))}
			{Array.from({ length: childCount }, (_, index) => (
				<IconChild key={`child-${index}`} />
			))}
			{Array.from({ length: babyCount }, (_, index) => (
				<IconBaby key={`baby-${index}`} />
			))}
		</div>
	);
};

RoomCapacity.propTypes = {
	adultCount: PropTypes.number,
	childCount: PropTypes.number,
	babyCount: PropTypes.number,
};

export default memo(RoomCapacity);
